import type { Contract } from '../types';
import type { TaxableAmount } from '@paid-ui/types/payments';
import type { RetainableInfo } from '@paid-ui/types/retentions';

import { contractManager } from '../model';
import { savePeriodicPermissions } from './savePeriodicPermissions';
import { savePermissions } from './savePermissions';

export const saveRetentions = (contract?: Contract) => {
  if (!contract) return;

  const { retentions, retentionSchedule } = contract;

  contractManager.retentions = retentions ?? [];
  contractManager.retentionSchedule = retentionSchedule ?? null;
};

export const saveRetainableInfo = (
  data: RetainableInfo,
  options?: {
    offPlatform?: {
      retained: TaxableAmount;
    };
    onPlatform?: {
      balance: TaxableAmount;
      released: TaxableAmount;
      retained: TaxableAmount;
      unretained: TaxableAmount;
      onboarded: TaxableAmount;
      overRetained: TaxableAmount;
    };
  },
) => {
  contractManager.retainableInfo = data;
  if (options?.onPlatform) {
    contractManager.onPlatformRetainable = options.onPlatform;
  }
  if (options?.offPlatform) {
    contractManager.offPlatformRetainable = options.offPlatform;
  }

  // canClaimRetention reads retainableInfo / onPlatformRetainable. saveContract()
  // computes permissions before the breakdown query resolves, so without this
  // re-run the Retention Claim button stays disabled until the next contract reload.
  if (contractManager.statuses.isPeriodic) {
    savePeriodicPermissions();
  } else {
    savePermissions();
  }
};
